export default "__VITE_ASSET__e0d91685__"